import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserServiceService } from 'src/app/admin/services/user/userService/user-service.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';
import { MessagingService } from '../../services/messaging/messaging.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit {

  constructor(
    private toast: ToastrService,
    private ngxSpinner: NgxSpinnerService,
    private userdata: UserdataService,
    private router: Router,
    private userservice: UserServiceService,
    // private messagingService: MessagingService
  ) { }

  loginForm = new UntypedFormGroup({
    //email: new FormControl('', [Validators.required]),
    //password: new FormControl('', [Validators.required]),
    email: new UntypedFormControl('', [Validators.required]),
    password: new UntypedFormControl('', [Validators.required]),
    recaptcha: new UntypedFormControl('', [Validators.required]),
    is_social_login: new UntypedFormControl(false, [Validators.required]),
    is_web: new UntypedFormControl(true, [Validators.requiredTrue]),
    device_type: new UntypedFormControl('web', [Validators.required]),
    fcm_token: new UntypedFormControl(''),
  });

  ngOnInit(): void {
    if (this.userdata.getData() != null) {
      this.router.navigateByUrl('/admin/dashboard')
    }
    // this.messagingService.requestPermission()
    // this.messagingService.receiveMessage()
  }

  get f() {
    return this.loginForm.controls
  }

  public onLogin() {
    this.ngxSpinner.show()
    this.loginForm.patchValue({ fcm_token: this.userdata.getFcm() })
    this.userservice.deleteFcm({ token: this.userdata.getFcm() }).subscribe(
      (res: any) => {
        this.userservice.login(this.loginForm.value).subscribe(
          (res: any) => {
            this.ngxSpinner.hide()
            this.toast.success('Login Successfully', 'Success')
            this.userdata.setData(res);
            //console.log(res)
            this.router.navigateByUrl('admin/dashboard')
          },
          err => {
            this.ngxSpinner.hide()
            this.toast.error(err.error.message, 'Error')
            this.reloadCurrentRoute()
          }
        )
      }, err => {
        this.toast.error(err.error.message, 'Error')
      }
    )
  }

  handleLoad() {
    //console.log('ok')
  }

  handleSuccess(event: any) {
    //console.log(event, this.loginForm.get('recaptcha')?.value)
  }

  siteKey: string = '6LfG4zstAAAAAATcvcb-xRrxH1IQAGayN-0R8YnP'

  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  showPassword = 'password';


  toggelShowPassword(type: string): void {
    if (type === 'text') {
      this.showPassword = 'password';
    } else {
      this.showPassword = 'text';
    }
  }
}
